<template>
  <div>
    <a-form class="iotplt-nested-search-form" :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="ICCID">
            <a-input
              v-decorator="['iccid', { normalize: this.$lodash.trim }]"
              allow-clear
              placeholder="支持模糊搜索"
            />
          </a-form-item>
        </a-col>

        <a-col :span="6">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">搜索</a-button>
              <a-button @click="handleReset">刷新</a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
export default {
  name: 'SearchEsimProfileList',
  data() {
    return {
      form: this.$form.createForm(this, { name: 'esim_profile_list_search' })
    }
  },
  methods: {
    buildSearchParams(values) {
      const search = {}
      Object.keys(values || {}).forEach((key) => {
        const value = values[key]
        if (value === undefined || value === null || value === '') {
          return
        }
        search[key] = value
      })
      return search
    },

    handleSearch(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$emit('submit', this.buildSearchParams(values))
        }
      })
    },

    handleReset() {
      this.form.resetFields()
      this.$emit('submit', {})
    }
  }
}
</script>
